import onClickOutside from 'react-onclickoutside';
import PropTypes from 'prop-types';
import React from 'react';

class OutsideClickHandlerBase extends React.Component {
  handleClickOutside(evt) {
    this.props.onClickOutside(evt);
  }

  render() {
    return this.props.children;
  }
}

const OutsideClickHandler = onClickOutside(OutsideClickHandlerBase);

OutsideClickHandler.defaultProps = {
  eventTypes: ['click', 'touchend'],
};

OutsideClickHandlerBase.propTypes = {
  children: PropTypes.node.isRequired,
  onClickOutside: PropTypes.func.isRequired,
};

OutsideClickHandler.propTypes = {
  ...OutsideClickHandlerBase.propTypes,
  disableOnClickOutside: PropTypes.bool,
};

export default OutsideClickHandler;



// WEBPACK FOOTER //
// ./src/scripts/presentation/components/common/utilities/outside_click_handler.jsx